import NonMedicareTotals from "./NonMedicareTotals";

export default NonMedicareTotals;